/* eslint-disable react-hooks/exhaustive-deps */
import { debounce } from 'lodash';
import React, { useCallback } from 'react'
import { GitCompare } from 'react-ionicons'
import { Link } from 'react-router-dom'
import { animateLetters, animateLettersReverse } from '../../pages/Home/helperAnimations';
import { useNavigate } from "react-router-dom";
function Navbar() {
    const debouncedChangeHandler = useCallback(debounce(animateLetters, 500), []);

// eslint-disable-next-line react-hooks/exhaustive-deps
const debouncedChangeHandlerReverse = useCallback(
  debounce(animateLettersReverse, 500),
  []
);

const navigate = useNavigate()
  return (
    <div className="navlinks">
    <div
      className="logo"
      onMouseEnter={() => animateLetters()}
      onMouseLeave={() => animateLettersReverse()}
      onClick={() => navigate('/')}
    >
      <GitCompare
        color={"#6adb9d"}
        height="20px"
        width="20px"
        // onClick={() => alert("Hi!")}
        title={"Options"}
      />
      <div className="logonamecontainer">
        <div className="logoname">
          {" "}
          <p className="letterToFloat first">U</p>
          <p>DOKA</p>
        </div>
        <div className="logoname">
          {" "}
          <p>MBAJIAK</p>
          <p className="letterToFloat last">U</p>
        </div>
      </div>
    </div>
    <ul className="contacthead">
      <li className="contact">
        <Link to="/projects" className="contact-link">
          PROJECTS
        </Link>
      </li>
      <li className="contact">
        <Link to="/about" className="contact-link">
          ABOUT
        </Link>
      </li> 
    </ul>
  </div>
  )
}

export default Navbar